import { BaseItem } from './common';

export enum Source {
  Predict = 'PREDICT',
  Fingerprint = 'FINGERPRINT',
  Analyst = 'ANALYST',
  External = 'EXTERNAL',
  Dictation = 'DICTATION',
}

export interface EmCode extends BaseItem {
  encounterId: string;
  code: string;
  source: Source;
}
